import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-info-popup',
  templateUrl: './info-popup.component.html',
  styleUrls: ['./info-popup.component.css']
})
export class InfoPopupComponent implements OnInit {

  message: string = 'Settings day';
  bodyText: string = '';

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/popups/info-popup/info-popup.component.ts